export default __webpack_public_path__ + "static/media/third_icon.fb0e9b80.svg";